import { Component, OnInit,Input,Output,EventEmitter} from '@angular/core';
import { LoginService } from './../login.service';
import { SettingsService } from '../settings.service';
import { AppointmentsService } from '../appointments.service';
import { TranslateService } from '@ngx-translate/core';
import { UntypedFormGroup,UntypedFormBuilder } from "@angular/forms";

@Component({
    selector: 'app-search-appointments',
    templateUrl: './search-appointments.component.html',
    styleUrls: ['./search-appointments.component.scss'],
    standalone: false
})
export class SearchAppointmentsComponent implements OnInit {
  @Output() closed = new EventEmitter<string>();
  exams=[]
  searchForm:UntypedFormGroup
  slots=[]
  loadingSlots=false
  constructor(public settings:SettingsService,public ls:LoginService,private translate: TranslateService,private fb:UntypedFormBuilder,public aptS:AppointmentsService) { }

  ngOnInit(): void {
    this.searchForm = this.fb.group({
      examType:[null],
      byRoom:[this.ls.premissions.ApptsByRoom? true:false]
    });
    this.settings.getExams().then((data)=>{
      this.exams= data
      
      
     });
  }

  getTranslatedExamType(examType: string): string {
    const translationKey = `appointments.gui.exams.${examType}`;
    const translated = this.translate.instant(translationKey);
    return translated === translationKey ? examType : translated;
  }
  
  close(appointment=null) {
    if(appointment){
      appointment.examType=this.searchForm.get('examType').value
    }
    this.closed.emit(appointment);
  }

  

  getExamTypes(){
    return this.exams
   }


   searchSlots(){
    this.loadingSlots=true
    this.aptS.searchAvailableSlots(this.searchForm.value).subscribe((data)=>{
     this.loadingSlots=false
     this.slots=data['slots']
    },(error)=>{
      this.loadingSlots=false;
      this.slots=[]
      throw new Error(error)
    })
   }

   getExamName(exam): string {
   
    return exam.custom ? exam.examType : exam.examName;
  }



}
